export default __webpack_public_path__ + "static/media/stockPhoto1.981ada41.jpg";